import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ToastService } from "./toast.service";
import { Observable } from "rxjs";

@Injectable()
export class CityService {
  private base_url = `${environment.API_URL}/cities`;
  private single_url = `${environment.API_URL}/city`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(private http: HttpClient, private toast: ToastService) {}

  // Get all cities
  getCities(params) {
   
    return this.http
      .post(this.base_url, params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  //get single city
  getCity(city_id:number) {
    return this.http
      .get(`${this.single_url}/${city_id}?token=${this.token}`, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  // autocomplete cities
  autocompleteCities(query) {
    let params = {
      //token: this.token,
      query: query,
    };
    return this.http
      .post(`${this.base_url}/autocomplete`, params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  // create city
  createCity(params) {
    //params["token"] = this.token;
    return this.http
      .post(this.single_url, params, { headers: this.headers })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response.id) {
          // If the response is an Object with an ID, this means a success
          this.toast.success("Ville Ajoutée avec succès.", false, "Ville");
        } else {
          this.toast.error(
            "Erreur lors de l'ajout de la ville.",
            false,
            "Ville"
          );
        }
        return response;
      });
  }

  //delete city
  deleteCity(city_id: number) {
    return this.http
      .delete(`${this.single_url}/${city_id}?token=${this.token}`, {
        headers: this.headers,
      });
  }

  //update city
  updateCity(city_id: number, params) {
    return this.http
      .patch(`${this.single_url}/${city_id}?token=${this.token}`, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success(
            "Ville Mise à jour avec succès.",
            false,
            "Ville"
          );
        } else {
          this.toast.error(
            "Erreur lors de la mise à jour de la ville.",
            false,
            "Ville"
          );
        }
      });
  }

  getOrCreateCountry(name: string): Observable<any> {
    return this.http.post(`${environment.API_URL}/get-or-create-countries`, { name }, { headers: this.headers });
  }

  // Vérifier ou créer une région (area)
  getOrCreateArea(region: string, countryId: number): Observable<any> {
    return this.http.post(`${environment.API_URL}/get-or-create-area`, { region, countryId }, { headers: this.headers });
  }

  // Vérifier ou créer une ville
  getOrCreateCity(name: string, areaId: number): Observable<any> {
    return this.http.post(`${environment.API_URL}/get-or-create-city`, { name, areaId }, { headers: this.headers });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/city.service.ts